import { generalEnv } from '@nx-frontend/shared/env';
import { Session, sessionFromDto } from '@nx-frontend/shared/types';
import { getSession } from './services';

/**
 * Get session by cookie
 * @param req
 * @returns
 */
export const getSessionByCookie = async (req: Request) => {
  const cookies = req.headers.get('cookie') || '';
  const sessionIdMatch = cookies.match(/eversessionid=([^;]+)/);
  const sessionId = sessionIdMatch ? sessionIdMatch[1] : null;
  let session: Session | null = null;

  if (sessionId) {
    try {
      session = sessionFromDto(await getSession({ host: generalEnv.userServiceUrl, sessionId }));
    } catch (err) {
      // Silently skip session error
    }
  }

  return session;
};
